import React from 'react';
import PropTypes from 'prop-types';

import { MAIN_CONTENT_ID } from './constants';

const LayoutLogin = ({ children, isMainLandmark = true }) => {
  // == Solo el shell de página emite el landmark main; anidado renderiza un div para no
  // == duplicarlo ni duplicar el id del skip link.
  const ContentTag = isMainLandmark ? 'main' : 'div';
  const mainLandmarkProps = isMainLandmark ? { id: MAIN_CONTENT_ID, tabIndex: -1 } : {};

  return (
    <div className="layout-login">
      <ContentTag className="layout-login__column-1" {...mainLandmarkProps}>
        {children?.[0]}
      </ContentTag>
      <div className="layout-login__column-2">{children?.[1]}</div>
    </div>
  );
};

LayoutLogin.propTypes = {
  children: PropTypes.array,
  isMainLandmark: PropTypes.bool,
};

LayoutLogin.defaultProps = {
  children: [<div key="layout-login-column-1"></div>, <div key="layout-login-column-2"></div>],
};

export default LayoutLogin;
